import propsResolver from "@insightfulscience/shared-utils/fn/props-resolver";
import { extRightStrict } from "@insightfulscience/shared-utils/either";
import setSequencesData from "@src/Plasmids/providers/getPlasmidSequences";
import sets from "@src/Plasmids/providers/getPlasmidSets";
import { encodeURLFragment } from "@src/Plasmids/utils/encodeURLFragment";

export default propsResolver({
	setSequencesData: ({ query }, services) =>
		setSequencesData(encodeURLFragment(query.setID))(services).then(extRightStrict),
	sets,
});
